module.exports = __webpack_public_path__ + "img/model_69_ug.e258f2eb.png";